import { HiExclamation } from 'react-icons/hi'

import { Box, Flex } from '@chakra-ui/react'

import { TourPlanI } from '../types/types'

interface RemoveCheckpointWarningIProps {
  tourPlans: TourPlanI[]
}

export const RemoveCheckpointWarning = ({
  tourPlans,
}: RemoveCheckpointWarningIProps) => {
  return (
    <Flex
      color='#D11D3A'
      flexDirection='column'
      fontSize='14px'
      fontWeight='medium'
      letterSpacing='-0.53px'
    >
      <Flex alignItems='center' flexDirection='row' mt='5'>
        <Box>
          <HiExclamation size='36px' />
        </Box>
        <Box ml='4px'>
          This checkpoint is associated with the following tourplans and must be
          removed from these tourplans before it can be removed from the floor.
        </Box>
      </Flex>
      <Flex flexDirection='column' ml='40px'>
        {tourPlans.map(({ name, id }) => (
          <Box key={id}>{`\u2022 ${name}`}</Box>
        ))}
      </Flex>
    </Flex>
  )
}
